import { AnimatePresence, motion } from "framer-motion";
import { EASE } from "./SlideKit";
import { SlideTitle, Slide1, Slide2, Slide3, Slide4, Slide5 } from "./SlidesA";
import { Slide6, Slide7, Slide8, Slide9, SlideCapacity, Slide10, SlideClosing } from "./SlidesB";

const SLIDES = [SlideTitle, Slide1, Slide2, Slide3, Slide4, Slide5, Slide6, Slide7, Slide8, Slide9, SlideCapacity, Slide10, SlideClosing];

export const SLIDE_COUNT = SLIDES.length;

export const SlideDeck = ({ index }) => {
  const Current = SLIDES[index];
  return (
    <div className="absolute inset-0" data-testid={`slide-${index}`}>
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7, ease: EASE }}
          className="w-full h-full"
        >
          <Current />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
